import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule, LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment from 'moment-timezone';
import { Subscription } from 'rxjs';
import { EmptyObject, WebUtils } from '../common/utils';
import { AccessUtils, inviteLink, TBooking, TBookingParticipant, TSpace } from '../core/entities';
import { SiteLangMixin } from '../core/lang';
import { SitePathMixin } from '../core/site.path.utils';
import { SessionCache } from '../session.cache';
import { SessionService } from '../session.service';
import { BookingCalendarUtils } from '../thinkdesks/booking.calendar.utils';
import { SiteFormatMixin } from '../thinkdesks/site.format.mixin';
import { TBookingStatus } from '../thinkdesks/thinkdesks.entities';
import { BookingCancelDialogComponent } from './booking.cancel.dialog';
import { BookingSharingService } from './booking.sharing';
import { MyBookingUpateNumParticipantsDialogComponent } from './my.booking.update.num.participants.dialog';
import { SpaceCard } from './space.card';

@Component({
  selector: 'app-my-booking-page',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, SpaceCard, MatMenuModule],
  templateUrl: './my.booking.page.html',
})
export class MyBookingPage extends SiteLangMixin(
  SiteFormatMixin(SitePathMixin(EmptyObject))
) {
  @HostBinding('class') css = 'max-scroll';
  susbcription: Subscription;
  id: number;
  _common = _common;

  object: TBooking;
  openingHours: string[] = [];
  now: moment.Moment;
  nowTime: moment.Moment;
  date: moment.Moment;
  statusList = TBookingStatus;
  inviteUrl: string

  participants: TBookingParticipant[] = [];
  walkins: TBookingParticipant[] = [];
  constructor(
    public sharing: BookingSharingService,
    private dialog: MatDialog,
    private locationStrategy: LocationStrategy,
    private route: ActivatedRoute,
    private router: Router,
    public override session: SessionService,
    private cache: SessionCache,
    private http: HttpClient,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar
  ) {
    super();
  }
  isOwner = false;
  isParticipant = false;
  isWalkin = false;

  ngOnInit() {
    this.susbcription = this.route.paramMap.subscribe((result) => {
      this.id = parseInt(result.get('id'));

      this.nowTime = moment();
      this.now = this.nowTime.clone().startOf('day');
      this.refresh();
    });
  }
  ngOnDestroy() {
    this.susbcription.unsubscribe();
  }
  refresh() {
    window.scrollTo(0, 0);
    WebUtils.web_result(
      this.http.get(`/api/client/booking/${this.id}/retrieve`),
      async (result) => {
        this.object = result;
        this.object.participants = this.object.participants ?? [];  //newly added
        this.object.walkins = this.object.walkins ?? [];  //newly added
        AccessUtils.fixBooking(this.object);
        AccessUtils.fixSpace(this.object.space as TSpace);
        this.date = this.object.startTime.clone().startOf('day');

        this.isOwner = this.object.member.id == this.session.user.id
        this.isParticipant = this.object.participants?.some(p => !p.walkin && p?.member.id === this.session.user.id);  //newly added
        this.isWalkin = this.object.participants?.some(p => p.walkin && p?.member.id === this.session.user.id);  //newly added

        if (this.object.numParticipants)
          this.inviteUrl = await this.inviteLink();
        this.participants = this.object.participants.filter((c) => !c.walkin)
        this.walkins = this.object.participants.filter((c) => c.walkin)
        let location = this.object.space?.location;
        let s =
          this.lang(location?.openingHours, location?.openingHours_lang) ?? '';
        this.openingHours = s.split('\n');
      }
    );
  }
  googleCalendar() {
    BookingCalendarUtils.googleCalendar(this.locationStrategy, this.object);
  }
  bookAgain() {
    this.router.navigate([`/space/${this.object.space.id}`]);
  }
  cancelBooking() {
    let ref = this.dialog.open(BookingCancelDialogComponent, {
      data: {
        object: this.object
      }
    })
    ref.afterClosed().subscribe((result) => {
      if (result) {
        WebUtils.web_result(
          this.http.post(`/api/public/booking/cancel/${this.object.id}`, result),
          (result) => {
            let object = result as TBooking;
            AccessUtils.fixBooking(object);
            Object.assign(this.object, object);
          }
        );
      }
    })

  }
  showQrCode() {
    this.session.showQrCode({
      router: this.router,
      dialog: this.dialog,
    });
  }
  copyPasscode() {
    this.clipboard.copy(this.object.passcode);
    this.snackBar.open(_common.copied);
  }

  // private bufferToHex(buffer: ArrayBuffer): string {
  //   return Array.from(new Uint8Array(buffer))
  //     .map(b => b.toString(16).padStart(2, '0'))
  //     .join('');
  // }

  async inviteLink() {
    let url = inviteLink(this.session.lang, this.object);

    return url;
  }

  editNumParticipants() {
    let ref = this.dialog.open(MyBookingUpateNumParticipantsDialogComponent, {
      data: {
        object: this.object
      }
    })
    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.object.numParticipants = result.numParticipants

      }


    })
  }

  isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      || ('ontouchstart' in window)
      || navigator.maxTouchPoints > 0;
  }

  smartShare(object: any) {
    if (this.isMobileDevice()) {
      // Mobile browser → use native share or your mobile-specific link
      this.sharing.share_toApp(object);
    } else {
      // Desktop → open Web Share or fallback link
      this.sharing.share(object);
    }
  }
}
